import React from "react";
import { Navigate, Routes, Route } from "react-router-dom";
import { ErrorPage1 } from "./ErrorPage1";
import { ErrorPage2 } from "./ErrorPage2";
import { ErrorPage3 } from "./ErrorPage3";

export default function ErrorsPage() {
  return (
    <Routes>
      <Route path="/error" element={<Navigate to="/error/error-v1" replace />} />
      <Route path="/error/error-v1" element={<ErrorPage1 />} />
      <Route path="/error/error-v2" element={<ErrorPage2 />} />
      <Route path="/error/error-v3" element={<ErrorPage3 />} />
    </Routes>
  );
}
